import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Select,
  DatePicker,
  Button,
  Row,
  Col,
  Card,
  Divider,
  Spin,
  Radio,
  notification,
} from "antd";
import GlobalContext from "../../context/GlobalContext";
import { useTranslation } from "react-i18next";
import classes from "../Etablissements/Etablissements.module.css";
import { ChevronLeft } from "lucide-react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  fetchCodePostalList,
  fetchDelegationList,
  fetchDelegationListByGoverment,
  fetchPostalCodeListByDelegation,
  getCommuneByCodeCommune,
} from "../../context/FetchLists";
import {
  checkCitizenStatusByCinDn,
  checkCitizenStatusByIdMadDn,
  checkEleveByIdCINJ,
} from "../../api/extern";
import {
  addApprenant,
  getFormationById,
  getInfoApprenant,
  getInfoApprenantByCinOrPasseport,
  updateActionAffaire,
  updateAffaire,
  uploadDocApprenant,
} from "../../api/geoprod";
import DetailsDrawer from "./DetailsDrawer";
import dayjs from "dayjs";
import { InboxOutlined, SearchOutlined } from "@ant-design/icons";
import TextArea from "antd/es/input/TextArea";
import axiosInstance from "../../utils/axios";
import { useSessionStorageState } from "ahooks";
import Dragger from "antd/es/upload/Dragger";
import { useLoader } from "../../context/LoaderContext";

const { Option } = Select;

const PreInscritForm = () => {
  const { t } = useTranslation();
const { setIsLoading } = useLoader();
  const [form] = Form.useForm();
  const { id } = useParams();
  const params = useLocation();
  const { gouvernoratOptions, nationalityOptions } =
    React.useContext(GlobalContext);

  const [coursData, setCoursData] = React.useState(null);
  const [nationalité, setNationalité] = React.useState("تونسية");
  const [delegations, setDelegations] = React.useState([]);
  const [postalCodeList, setPostalCodeList] = React.useState([]);
  const [loader, setLoader] = useState(false);
  const [visibleForm, setVisibleForm] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [niveauScolaire, setNiveauScolaire] = useState([]);
  const idsEtabOrigineMinistere = [
    parseInt(import.meta.env.VITE_APP_ID_ETABLISSEMENT_ORIGINE_MINISTERE_EDUCATION),
    parseInt(import.meta.env.VITE_APP_ID_ETABLISSEMENT_ORIGINE_MINISTERE_ENSEIGNEMENT_SUPERIEUR)
  ]
const dataAffaire = params?.state?.dataAffaire
const id_specialite = params?.state?.id_specialite
  const [defaultDisabledFields, setDefaultDisabledFields] = React.useState({
    first_name: false,
    last_name: false,
    first_name_ar: false,
    last_name_ar: false,
    father_name: false,
    mother_name: false,
    father_name_ar: false,
    mother_name_ar: false,
    gender: false,
    birthplace: false,
    niveau_scolaire: false,
  });
  // const niveauScolaire = [
  //   {
  //     value: "إبتدائي",
  //     label: "Primaire - إبتدائي",
  //   },
  //   {
  //     value: "ثانوي",
  //     label: "Secondaire - ثانوي",
  //   },
  //   {
  //     value: "جامعي",
  //     label: "Universitaire - جامعي",
  //   },
  //   {
  //     value: "تكوين مهني",
  //     label: "Formation professionnelle - تكوين مهني",
  //   },
  // ];
  const [etablissementFormation, setEtablissementFormation] =
    useSessionStorageState("etablissement-formation", { defaultValue: [] });
  const [autreEtablissementCheck, setAutreEtablissementCheck] = React.useState({
    value: "",
    check: false,
  });
  const navigate = useNavigate();

  useEffect(() => {
    async function fetchData() {
      setLoader(true);
      getFormationById(id)
        .then((response) => {
          setCoursData(response?.message[0]);
          const formattedNiveaux = response?.message[0].min_niveau_requis?.map(item => ({
            value: item,
            label: item,
          }));
          setNiveauScolaire(formattedNiveaux);
          axiosInstance
            .get(
              `${
                import.meta.env.VITE_APP_GEOPROD_API
              }/config/etablissement_formation/list`
            )
            .then((res) => {
              const formattedData =
                res?.data?.data?.map((item) => ({
                  label: item?.name,
                  value: item?.id,
                })) || [];
              setEtablissementFormation(formattedData);
              setLoader(false);
            })
            .catch(() => {
              setLoader(false);
            });
        })
        .catch((error) => {
          notification.error({
            message: t("Erreur"),
            description: t(error?.data?.message),
            duration: 0,
          });
          setLoader(false);
        });
      if (
        params?.state?.type === "modification" ||
        params?.state?.type === "consulter" || params?.state?.type === "complement_dossier"
      ) {
        getInfoApprenant(params?.state?.id_apprenant)
          .then(async (response) => {
    //             if (response?.mainProspect?.documents?.content) {
    //   // const newFileList = { ...fileList };
    //   // const currentFormValues = form?.getFieldsValue();

    //   // form.setFieldsValue(currentFormValues);
    //   setFileList( {
    //         uid: "1",
    //         name: response?.mainProspect?.documents?.name,
    //         status: "done",
    //         url: response?.mainProspect?.documents?.content,
    //       });
    // }

            if (params?.state?.type === "modification" || params?.state?.type === "complement_dossier") {
              setDefaultDisabledFields(
                JSON.parse(response?.mainProspect?.data_from)
              );
            } else {
              setDefaultDisabledFields({
                first_name: true,
                last_name: true,
                first_name_ar: true,
                last_name_ar: true,
                father_name: true,
                mother_name: true,
                father_name_ar: true,
                mother_name_ar: true,
                gender: true,
                birthplace: true,
                niveau_scolaire: true,
              });
            }

            setVisibleForm(true);
            setNationalité(response?.mainProspect?.nationality);
            if (
              response?.mainProspect?.etablissement_formation_origine_autre &&
              response?.mainProspect?.etablissement_formation_origine
            ) {
              setAutreEtablissementCheck((prevState) => ({
                ...prevState,
                check: true,
              }));
            }
            let etab_origin = "";
            if (response?.mainProspect?.nationality === "تونسية") {
              etab_origin =
                response?.mainProspect?.etablissement_formation_origine;
            } else {
              etab_origin = response?.mainProspect
                ?.etablissement_formation_origine_autre
                ? response?.mainProspect?.etablissement_formation_origine_autre
                : "";
            }
            form.setFieldsValue({
              ...form.getFieldsValue(),
              nationality: response?.mainProspect?.nationality,
              etab_origin: etab_origin,
              autre_textarea:
                response?.mainProspect?.etablissement_formation_origine_autre,
              date_naissance: dayjs(
                response?.mainProspect?.DN,
                "YYYY/MM/DD"
              ).isValid()
                ? dayjs(response?.mainProspect?.DN, "YYYY/MM/DD")
                : "",
              num_cin: response?.mainProspect?.cin,
              num_extrait_naissance: response?.mainProspect?.extrait_naissance,
              num_passeport: response?.mainProspect?.passport,
              date_expiration_passeport: dayjs(
                response?.mainProspect?.expiration_passeport,
                "YYYY/MM/DD"
              ).isValid()
                ? dayjs(
                    response?.mainProspect?.expiration_passeport,
                    "YYYY/MM/DD"
                  )
                : "",
              num_carte_sejour: response?.mainProspect?.carde_number,
              id_ministere_education: response?.mainProspect?.id_ministry,
              last_name: response?.mainProspect?.name,
              first_name: response?.mainProspect?.surname,
              last_name_ar: response?.mainProspect?.name_ar,
              first_name_ar: response?.mainProspect?.surname_ar,
              birthplace: response?.mainProspect?.lieu_naissance,
              residence_governorate: response?.mainProspect?.goverment,
              residence_delegation: response?.mainProspect?.delegation,
              residence_postal_code: response?.mainProspect?.code_postal,
              father_name: response?.mainProspect?.nom_pere,
              father_name_ar: response?.mainProspect?.nom_pere_ar,
              mother_name: response?.mainProspect?.nom_mere,
              mother_name_ar: response?.mainProspect?.nom_mere_ar,
              gender: response?.mainProspect?.civilite,
              marital_status: response?.mainProspect?.etat_civile,
              email: response?.mainProspect?.adresse_mail,
              phone: response?.mainProspect?.tel,
              niveau_scolaire: response?.mainProspect?.niveau_etud,
              besoins_specifiques:
                response?.mainProspect?.besoin_specifique === 1 ? "نعم" : "لا",
            });

            const delegations = await fetchDelegationListByGoverment(
              response?.mainProspect?.goverment
            );
            setDelegations(delegations.map((e) => ({ ...e, label: e.text })));
            const code_postaux = await fetchPostalCodeListByDelegation(
              response?.mainProspect?.delegation
            );
            setPostalCodeList(code_postaux);
          })
          .catch((error) => {
            notification.error({
              message: t("Erreur"),
              description: t(error?.data?.message),
              duration: 0,
            });
          });
      }
    }

    if (id) {
      fetchData();
    }
  }, [id]);
  const addPreInscrit = () => {
    setLoader(true);
    let etab_formation_origine_autre = "";
    if (form.getFieldsValue()["nationality"] !== "تونسية") {
      etab_formation_origine_autre = form.getFieldsValue()["etab_origin"];
    } else if (autreEtablissementCheck?.check) {
      etab_formation_origine_autre = form.getFieldsValue()["autre_textarea"];
    }
    // debugger
    const payload = {
      adresse_mail: form.getFieldsValue()["email"],
      civilite: form.getFieldsValue()["gender"],
      name: form.getFieldsValue()["last_name"],
      surname: form.getFieldsValue()["first_name"],
      DN: dayjs(form.getFieldsValue()["date_naissance"], "DD/MM/YYYY").format(
        "YYYY-MM-DD"
      ),
      tel: form.getFieldsValue()["phone"],
      mobile: form.getFieldsValue()["phone"],
      nationality: form.getFieldsValue()["nationality"],
      cin: form.getFieldsValue()["num_cin"]
        ? form.getFieldsValue()["num_cin"]
        : "",
      passport: form.getFieldsValue()["num_passeport"]
        ? form.getFieldsValue()["num_passeport"]
        : "",
         expiration_passeport: form.getFieldsValue()["date_expiration_passeport"]
        ? dayjs(form.getFieldsValue()["date_expiration_passeport"] , "DD/MM/YYYY").format(
        "YYYY-MM-DD"
        ) 
        : "",
     
      extrait_naissance: form.getFieldsValue()["num_extrait_naissance"]
        ? form.getFieldsValue()["num_extrait_naissance"]
        : "",
      carde_number: form.getFieldsValue()["num_carte_sejour"]
        ? form.getFieldsValue()["num_carte_sejour"]
        : "",
      id_ministry: form.getFieldsValue()["id_ministere_education"]
        ? form.getFieldsValue()["id_ministere_education"]
        : "",
      name_ar: form.getFieldsValue()["last_name_ar"],
      surname_ar: form.getFieldsValue()["first_name_ar"],
      lieu_naissance: form.getFieldsValue()["birthplace"],
      goverment: form.getFieldsValue()["residence_governorate"],
      delegation: form.getFieldsValue()["residence_delegation"],
      code_postal: form.getFieldsValue()["residence_postal_code"],
      nom_pere: form.getFieldsValue()["father_name"],
      prenom_pere: "",
      nom_mere: form.getFieldsValue()["mother_name"],
      prenom_mere: "",
      nom_pere_ar: form.getFieldsValue()["father_name_ar"],
      prenom_pere_ar: "",
      nom_mere_ar: form.getFieldsValue()["mother_name_ar"],
      prenom_mere_ar: "",
      etat_civile: form.getFieldsValue()["marital_status"],
      niveau_etud: form.getFieldsValue()["niveau_scolaire"],
      besoin_specifique:
        form.getFieldsValue()["besoins_specifiques"] === "نعم" ? 1 : 0,
      // etablissement_formation_origine: form.getFieldsValue()["etab_origin"]
      //   ? form.getFieldsValue()["etab_origin"]
      //   : "",
      etablissement_formation_origine_autre: etab_formation_origine_autre,
      id_formation: parseInt(id),
      data_from: {...defaultDisabledFields,id_specialite:id_specialite},
    };

    if (form.getFieldsValue()["nationality"] === "تونسية") {
      payload.etablissement_formation_origine =
        form.getFieldsValue()["etab_origin"];
    }

    addApprenant(payload)
      .then(async (response) => {
        uploadDocApprenant(fileList, response?.data?.id_apprenant)
          .then(async (responseUpload) => {
            setFileList([
              {
                uid: "-1",
                name: responseUpload?.url?.split('/')?.pop(),
                status: "done",
                url: responseUpload?.url,
              },
            ]);

            // notification.success({
            //   message:
            //     form.getFieldsValue()["nationality"] === "تونسية"
            //       ? t(
            //           `Le demandeur ${
            //             form.getFieldsValue()["last_name"] +
            //             " " +
            //             form.getFieldsValue()["first_name"]
            //           } est éligible à la formation. La demande a été ajoutée avec succès avec le statut Éligible.`
            //         )
            //       : t(
            //           `La demande d’éligibilité pour ${
            //             form.getFieldsValue()["last_name"] +
            //             " " +
            //             form.getFieldsValue()["first_name"]
            //           } a été ajoutée avec le statut À vérifier. Vous pouvez soumettre la demande de vérification à la Direction Régionale en cliquant sur « Demander la vérification »`
            //         ),
            //   duration: 0,
            // });

            
            notification.warning({
              message: t(
                      `La demande d’éligibilité pour ${
                        form.getFieldsValue()["last_name"] +
                        " " +
                        form.getFieldsValue()["first_name"]
                      } a été ajoutée avec le statut À vérifier. Vous pouvez soumettre la demande de vérification à la Direction Régionale en cliquant sur « Demander la vérification »`
                    ),
              duration: 0,
            });

            navigate(`/pre-inscrit`);
            setLoader(false);
          })
          .catch((error) => {
            notification.error({
              message: t("Erreur"),
              description: t(error?.data?.message),
              duration: 0,
            });
            setLoader(false);
          });
      })
      .catch((error) => {
        notification.error({
          message: t("Erreur"),
          description: t(error?.data?.message),
          duration: 0,
        });
        setLoader(false);
      });
  };


//   function updateInfoEligibilite(data) {
//   const formValues = form.getFieldsValue();

//   const newInfoEligibilite = data.infoEligibiliteEtrangers.map(item => {
//     if (item.name && formValues.hasOwnProperty(item.name)) {
//             let newValue = formValues[item.name];
//       return {
//         ...item,
//         value: formValues[item.name]
//       };
//     }
//     return item;
//   });

//   return {
//     ...data,
//     infoEligibiliteEtrangers: newInfoEligibilite
//   };
// }


function updateInfoEligibilite(data) {
  const formValues = form.getFieldsValue();

  const newInfoEligibilite = data?.infoEligibiliteEtrangers?.map(item => {
    if (item?.name && formValues.hasOwnProperty(item?.name)) {
      let newValue = formValues[item.name];
      
      if (item?.name === 'date_naissance' || item?.name === 'expiration_passeport') {
        if (newValue) {
          newValue = dayjs(newValue).format('DD/MM/YYYY');
        }
      }
    if (item?.name === 'gender') {
        if (newValue) {
          newValue = newValue === "Mr" ? "Masculin - ذكر" :"Féminin - أنثى";
        }
      }
         if (item?.name === 'besoins_specifiques') {
        if (newValue) {
          newValue = newValue === "نعم" ?  "Oui - نعم" :"Non - لا" ;
        }
      }

      return {
        ...item,
        value: newValue
      };
    }
    return item;
  });

  return {
    ...data,
    infoEligibiliteEtrangers: newInfoEligibilite
  };
}

  const updatePreInscrit = (type) => {
    setLoader(true);
    let etab_formation_origine_autre = "";
    if (form.getFieldsValue()["nationality"] !== "تونسية") {
      etab_formation_origine_autre = form.getFieldsValue()["etab_origin"];
    } else if (autreEtablissementCheck?.check) {
      etab_formation_origine_autre = form.getFieldsValue()["autre_textarea"];
    }
    const payload = {
      adresse_mail: form.getFieldsValue()["email"],
      civilite: form.getFieldsValue()["gender"],
      name: form.getFieldsValue()["last_name"],
      surname: form.getFieldsValue()["first_name"],
      DN: dayjs(form.getFieldsValue()["date_naissance"], "DD/MM/YYYY").format(
        "YYYY-MM-DD"
      ),
      tel: form.getFieldsValue()["phone"],
      mobile: form.getFieldsValue()["phone"],
      nationality: form.getFieldsValue()["nationality"],
      cin: form.getFieldsValue()["num_cin"]
        ? form.getFieldsValue()["num_cin"]
        : "",
      passport: form.getFieldsValue()["num_passeport"]
        ? form.getFieldsValue()["num_passeport"]
        : "",
      expiration_passeport: form.getFieldsValue()["date_expiration_passeport"]
        ? dayjs(form.getFieldsValue()["date_expiration_passeport"] , "DD/MM/YYYY").format(
        "YYYY-MM-DD")
        : "",
      extrait_naissance: form.getFieldsValue()["num_extrait_naissance"]
        ? form.getFieldsValue()["num_extrait_naissance"]
        : "",
      carde_number: form.getFieldsValue()["num_carte_sejour"]
        ? form.getFieldsValue()["num_carte_sejour"]
        : "",
      id_ministry: form.getFieldsValue()["id_ministere_education"]
        ? form.getFieldsValue()["id_ministere_education"]
        : "",
      name_ar: form.getFieldsValue()["last_name_ar"],
      surname_ar: form.getFieldsValue()["first_name_ar"],
      lieu_naissance: form.getFieldsValue()["birthplace"],
      goverment: form.getFieldsValue()["residence_governorate"],
      delegation: form.getFieldsValue()["residence_delegation"],
      code_postal: form.getFieldsValue()["residence_postal_code"].toString(),
      nom_pere: form.getFieldsValue()["father_name"],
      prenom_pere: "",
      nom_mere: form.getFieldsValue()["mother_name"],
      prenom_mere: "",
      nom_pere_ar: form.getFieldsValue()["father_name_ar"],
      prenom_pere_ar: "",
      nom_mere_ar: form.getFieldsValue()["mother_name_ar"],
      prenom_mere_ar: "",
      etat_civile: form.getFieldsValue()["marital_status"],
      niveau_etud: form.getFieldsValue()["niveau_scolaire"],
      besoin_specifique:
        form.getFieldsValue()["besoins_specifiques"] === "نعم" ? 1 : 0,
      etablissement_formation_origine_autre: etab_formation_origine_autre,
      id_formation: parseInt(id),
      data_from: {...defaultDisabledFields,id_specialite:id_specialite},
    };

    if (form.getFieldsValue()["nationality"] === "تونسية") {
      payload.etablissement_formation_origine =
        form.getFieldsValue()["etab_origin"];
    }
    axiosInstance
      .post(
        `${import.meta.env.VITE_APP_GEOPROD_API}/update_apprenant`,
        payload,
        {
          headers: {
            Idsession: JSON.parse(localStorage.getItem("-x-token-user"))
              ?.Acces_Token,
          },
        }
      )
      .then(async(res) => {
    // const dataEligibilite = dataAffaire?.response?.data?.infoEligibiliteEtrangers
    const updatedData = updateInfoEligibilite(dataAffaire?.response?.data);



     if (type === "complement_dossier")
      {

          const payload = {
            additional_form: "{}",
            json_prod: {...updatedData },
            registration_number: dataAffaire?.response?.data?.registration_number,
          };
          // debugger
          if (payload) {
            const data = await updateAffaire(
              params?.state?.id_affaire,
              payload,
              ""
            );
            if (data) {

         const dataUpdateStatus = await updateActionAffaire({
          id_affaire: params?.state?.id_affaire,
          id_status: import.meta.env
            .VITE_APP_ID_DEMANDE_ELIGIBILITE_DEMANDE_COMPLEMENT_SOUMIS,
        });

        if(dataUpdateStatus)
        {
          notification.success({
          message: t("Les informations fournies ont été ajoutées avec succès à votre demande"),
          duration: 6,
        });
        
        navigate(`/pre-inscrit`);
        setLoader(false);
        }

            } else {
            
              setIsLoading(false);

              notification.error({
                description: t("Enregistrement échoué, merci de réessayer."),
              });
            }
          }
        } 

          else 
          {
              notification.success({
                    message: t(res?.data?.message),
                    duration: 6,
                  });
                  
                  navigate(`/pre-inscrit`);
                  setLoader(false);
          }


      })
      .catch((error) => {
        notification.error({
          message: t("Erreur"),
          description: t(error?.response?.data?.message),
          duration: 0,
        });

        setLoader(false);
      });
  };
  const onFinish = async () => {
    if (params?.state?.type === "modification" || params?.state?.type === "complement_dossier") {
      updatePreInscrit(params?.state?.type );

      // if (params?.state?.type === "complement_dossier")
      // {
      // const dataUpdateStatus = await updateActionAffaire({
      //     id_affaire: params?.state?.id_affaire,
      //     id_status: import.meta.env
      //       .VITE_APP_ID_DEMANDE_ELIGIBILITE_DEMANDE_COMPLEMENT_SOUMIS,
      //   });

      //   if (dataUpdateStatus) {
      //     const payload = {
      //       additional_form: "{}",
      //       json_prod: { },
      //     };
      //     if (payload) {
      //       const data = await updateAffaire(
      //         params?.state?.id_affaire,
      //         payload,
      //         ""
      //       );
      //       if (data) {
           
      //         setIsLoading(false);
      //         notification.success({
      //           // message: t("Succès"),
      //           description: t(
      //             "Les informations fournies ont été ajoutées avec succès à votre demande. Vous recevrez bientôt une notification par email ou sur la plateforme."
      //           ),
      //           duration: 0,
      //         });
      //       } else {
            
      //         setIsLoading(false);

      //         notification.error({
      //           description: t("Enregistrement échoué, merci de réessayer."),
      //         });
      //       }
      //     }
      //   } else {
          
      //     // setIsLoading(false);

      //     notification.error({
      //       description: t("Enregistrement échoué, merci de réessayer."),
      //     });
      //   }

      // }

    } else {
      addPreInscrit();
    }
  };

  const handleGouvernoratChange = async (value) => {
    let selected_goverment = gouvernoratOptions.find(
      (e) => e.value === value
    ).id;
    let list_delegation = await fetchDelegationList(selected_goverment);

    form.setFieldsValue({
      ...form.getFieldsValue(),
      residence_delegation: "",
      residence_postal_code: "",
    });

    setDelegations(list_delegation.map((e) => ({ ...e, label: e.text })));
    setPostalCodeList([]);
  };

  const handleDelegationChange = async (value) => {
    let selected_delegation = delegations?.find((e) => e?.value === value).id;

    let list_code_postaux = await fetchCodePostalList(selected_delegation);

    form.setFieldsValue({
      ...form.getFieldsValue(),
      residence_postal_code: "",
    });

    setPostalCodeList(list_code_postaux);
  };
  const handleResetDisabledFields = (e) => {
    setNationalité(e);
    setDefaultDisabledFields({
      first_name: false,
      last_name: false,
      first_name_ar: false,
      last_name_ar: false,
      father_name: false,
      mother_name: false,
      father_name_ar: false,
      mother_name_ar: false,
      gender: false,
      birthplace: false,
      niveau_scolaire: false,
    });
    setAutreEtablissementCheck({
      value: "",
      check: false,
    });

    if (e !== "تونسية") {
      setVisibleForm(true);
    } else if (params?.state?.type !== "modification" && params?.state?.type !== "complement_dossier") {
      setVisibleForm(false);
    }

    if (params?.state?.type !== "modification" && params?.state?.type !== "complement_dossier") {
      const fieldsToReset = Object.keys(form.getFieldsValue()).filter(
        (field) => field !== "nationality"
      );
      form.resetFields(fieldsToReset);
    }
  };
  // const searchClick = () => {
  //   form
  //     .validateFields()
  //     .then(async () => {
  //       setLoader(true);
  //       if (
  //         autreEtablissementCheck.value === "Privé" &&
  //         nationalité === "تونسية"
  //       ) {
  //         getInfoApprenantByCinOrPasseport(form.getFieldsValue()["num_cin"])
  //           .then(async (response) => {
  //             form.setFieldsValue({
  //               ...form.getFieldsValue(),
  //               first_name: response?.prospect?.surname,
  //               last_name: response?.prospect?.name,
  //               first_name_ar: response?.prospect?.surname_ar,
  //               last_name_ar: response?.prospect?.name_ar,
  //               father_name: response?.prospect?.nom_pere,
  //               mother_name: response?.prospect?.nom_mere,
  //               father_name_ar: response?.prospect?.nom_pere_ar,
  //               mother_name_ar: response?.prospect?.nom_mere_ar,
  //               gender: response?.prospect?.civilite,
  //               birthplace: response?.prospect?.lieu_naissance,
  //               residence_governorate: response?.prospect?.goverment,
  //               residence_delegation: response?.prospect?.delegation,
  //               residence_postal_code: response?.prospect?.code_postal,
  //               marital_status: response?.prospect?.etat_civile,
  //               email: response?.prospect?.adresse_mail,
  //               phone: response?.prospect?.tel,
  //               niveau_scolaire: response?.prospect?.niveau_etud,
  //               besoins_specifiques:
  //                 response?.prospect?.besoin_specifique === 1 ? "نعم" : "لا",
  //             });

  //             const delegations = await fetchDelegationListByGoverment(
  //               response?.prospect?.goverment
  //             );
  //             setDelegations(delegations.map((e) => ({ ...e, label: e.text })));
  //             const code_postaux = await fetchPostalCodeListByDelegation(
  //               response?.prospect?.delegation
  //             );
  //             setPostalCodeList(code_postaux);

  //             setDefaultDisabledFields({
  //               first_name: !!response?.prospect?.surname,
  //               last_name: !!response?.prospect?.name,
  //               first_name_ar: !!response?.prospect?.surname_ar,
  //               last_name_ar: !!response?.prospect?.name_ar,
  //               father_name: !!response?.prospect?.nom_pere,
  //               mother_name: !!response?.prospect?.nom_mere,
  //               father_name_ar: !!response?.prospect?.nom_pere_ar,
  //               mother_name_ar: !!response?.prospect?.nom_mere_ar,
  //               gender: !!response?.prospect?.civilite,
  //               birthplace: !!response?.prospect?.lieu_naissance,
  //               niveau_scolaire: response?.prospect?.niveau_etud,
  //             });
  //             setLoader(false);
  //             setVisibleForm(true);
  //           })
  //           .catch((error) => {
  //             notification.error({
  //               message: t("Erreur"),
  //               description: t(error?.data?.message),
  //               duration: 0,
  //             });
  //             setLoader(false);
  //           });
  //       } else {
  //         checkCitizenStatusByIdMadDn(
  //           form.getFieldsValue()["num_extrait_naissance"],
  //           form.getFieldsValue()["date_naissance"]
  //         )
  //           .then(async (responseMad) => {
  //             const value = await checkCitizenStatusByCinDn(
  //               form.getFieldsValue()["date_naissance"],
  //               form.getFieldsValue()["num_cin"]
  //             );

  //             if (value !== false) {
  //               let lieu_naissance = await getCommuneByCodeCommune(
  //                 value?.commune
  //               );
  //               if (
  //                 responseMad.nom === value?.nomAr &&
  //                 responseMad.prenom === value?.prenomAr
  //               ) {
  //                 // if (
  //                 //   form.getFieldsValue()["id_ministere_education"] &&
  //                 //   autreEtablissementCheck.value === "Ministère de l'éducation"
  //                 // ) {
  //                 //   checkEleveByIdCINJ(
  //                 //     form.getFieldsValue()["num_cin"],
  //                 //     form.getFieldsValue()["num_extrait_naissance"]
  //                 //   )
  //                 //     .then(async (responseCheckEleve) => {
  //                 //       if (
  //                 //         responseMad.nom === responseCheckEleve?.data?.nom &&
  //                 //         responseMad.prenom ===
  //                 //           responseCheckEleve?.data?.prenom
  //                 //       ) {
  //                 //         form.setFieldsValue({
  //                 //           ...form.getFieldsValue(),
  //                 //           first_name: value?.prenomFr,
  //                 //           last_name: value?.nomFr,
  //                 //           first_name_ar: value?.prenomAr,
  //                 //           last_name_ar: value?.nomAr,
  //                 //           father_name: value?.chainePereFr,
  //                 //           mother_name: value?.chaineMereFr,
  //                 //           father_name_ar: value?.chainePereAr,
  //                 //           mother_name_ar: value?.chaineMereAr,
  //                 //           gender: value?.genre === "2" ? "Mme" : "Mr",
  //                 //           birthplace: lieu_naissance,
  //                 //           niveau_scolaire:
  //                 //             responseCheckEleve?.data?.niveau?.libelle,
  //                 //         });

  //                 //         setDefaultDisabledFields({
  //                 //           first_name: !!value?.prenomFr,
  //                 //           last_name: !!value?.nomFr,
  //                 //           first_name_ar: !!value?.prenomAr,
  //                 //           last_name_ar: !!value?.nomAr,
  //                 //           father_name: !!value?.chainePereFr,
  //                 //           mother_name: !!value?.chaineMereFr,
  //                 //           father_name_ar: !!value?.chainePereAr,
  //                 //           mother_name_ar: !!value?.chaineMereAr,
  //                 //           gender: !!value?.genre,
  //                 //           birthplace: !!lieu_naissance,
  //                 //           niveau_scolaire:
  //                 //             !!responseCheckEleve?.data?.niveau?.libelle,
  //                 //         });
  //                 //         setLoader(false);
  //                 //         setVisibleForm(true);
  //                 //       } else {
  //                 //         notification.error({
  //                 //           message: t("Erreur"),
  //                 //           description: t(
  //                 //             "Le num de l'identifiant de ME est erroné."
  //                 //           ),
  //                 //           duration: 0,
  //                 //         });
  //                 //         setLoader(false);
  //                 //       }
  //                 //     })
  //                 //     .catch((error) => {
  //                 //       notification.error({
  //                 //         message: t("Erreur"),
  //                 //         description: t(error?.data?.message),
  //                 //         duration: 0,
  //                 //       });
  //                 //       setLoader(false);
  //                 //     });
  //                 // } else {
  //                 //   form.setFieldsValue({
  //                 //     ...form.getFieldsValue(),
  //                 //     first_name: value?.prenomFr,
  //                 //     last_name: value?.nomFr,
  //                 //     first_name_ar: value?.prenomAr,
  //                 //     last_name_ar: value?.nomAr,
  //                 //     father_name: value?.chainePereFr,
  //                 //     mother_name: value?.chaineMereFr,
  //                 //     father_name_ar: value?.chainePereAr,
  //                 //     mother_name_ar: value?.chaineMereAr,
  //                 //     gender: value?.genre === "2" ? "Mme" : "Mr",
  //                 //     birthplace: lieu_naissance,
  //                 //     niveau_scolaire: "",
  //                 //   });

  //                 //   setDefaultDisabledFields({
  //                 //     first_name: !!value?.prenomFr,
  //                 //     last_name: !!value?.nomFr,
  //                 //     first_name_ar: !!value?.prenomAr,
  //                 //     last_name_ar: !!value?.nomAr,
  //                 //     father_name: !!value?.chainePereFr,
  //                 //     mother_name: !!value?.chaineMereFr,
  //                 //     father_name_ar: !!value?.chainePereAr,
  //                 //     mother_name_ar: !!value?.chaineMereAr,
  //                 //     gender: !!value?.genre,
  //                 //     birthplace: !!lieu_naissance,
  //                 //     niveau_scolaire: false,
  //                 //   });
  //                 //   setLoader(false);
  //                 //   setVisibleForm(true);
  //                 // }

  //                 // else if(form.getFieldsValue()["id_ministere_education"] && autreEtablissementCheck.value==="Ministère de l'Enseignement Supérieur et de la Recherche")
  //                 //   {
  //                 //     PrepVPaiements(form.getFieldsValue()["num_cin"],form.getFieldsValue()["date_naissance"]).then(async(responseCheckEleve) => {

  //                 //       if(responseMad.nom === responseCheckEleve?.nom && responseMad.prenom ===  responseCheckEleve?.prenom)
  //                 //       {
  //                 //         form.setFieldsValue({
  //                 //           ...form.getFieldsValue(),
  //                 //           first_name: value?.prenomFr,
  //                 //           last_name: value?.nomFr,
  //                 //           first_name_ar: value?.prenomAr,
  //                 //           last_name_ar: value?.nomAr,
  //                 //           father_name: value?.chainePereFr,
  //                 //           mother_name: value?.chaineMereFr,
  //                 //           father_name_ar: value?.chainePereAr,
  //                 //           mother_name_ar: value?.chaineMereAr,
  //                 //           gender: value?.genre === "2" ? "Mme" : "Mr",
  //                 //         });

  //                 //         setDefaultDisabledFields({
  //                 //           first_name: !!value?.prenomFr,
  //                 //           last_name: !!value?.nomFr,
  //                 //           first_name_ar: !!value?.prenomAr,
  //                 //           last_name_ar: !!value?.nomAr,
  //                 //           father_name: !!value?.chainePereFr,
  //                 //           mother_name: !!value?.chaineMereFr,
  //                 //           father_name_ar: !!value?.chainePereAr,
  //                 //           mother_name_ar: !!value?.chaineMereAr,
  //                 //           gender: !!value?.genre,
  //                 //         });
  //                 //         setLoader(false);
  //                 //         setVisibleForm(true);
  //                 //       }
  //                 //       else
  //                 //       {
  //                 //         notification.error({
  //                 //           message: t('Erreur'),
  //                 //           description: t("Le num de l'identifiant de MES est erroné."),
  //                 //           duration: 0,
  //                 //         });
  //                 //       setLoader(false);
  //                 //       }

  //                 //     })
  //                 //     .catch((error)=>
  //                 //       {
  //                 //         notification.error({
  //                 //           message: t("Erreur"),
  //                 //           description:
  //                 //             t(error?.data?.message),
  //                 //           duration: 0,
  //                 //         });
  //                 //         setLoader(false)
  //                 //       })

  //                 // }



                  
  //                   form.setFieldsValue({
  //                     ...form.getFieldsValue(),
  //                     first_name: value?.prenomFr,
  //                     last_name: value?.nomFr,
  //                     first_name_ar: value?.prenomAr,
  //                     last_name_ar: value?.nomAr,
  //                     father_name: value?.chainePereFr,
  //                     mother_name: value?.chaineMereFr,
  //                     father_name_ar: value?.chainePereAr,
  //                     mother_name_ar: value?.chaineMereAr,
  //                     gender: value?.genre === "2" ? "Mme" : "Mr",
  //                     birthplace: lieu_naissance,
  //                     niveau_scolaire: "",
  //                   });

  //                   setDefaultDisabledFields({
  //                     first_name: !!value?.prenomFr,
  //                     last_name: !!value?.nomFr,
  //                     first_name_ar: !!value?.prenomAr,
  //                     last_name_ar: !!value?.nomAr,
  //                     father_name: !!value?.chainePereFr,
  //                     mother_name: !!value?.chaineMereFr,
  //                     father_name_ar: !!value?.chainePereAr,
  //                     mother_name_ar: !!value?.chaineMereAr,
  //                     gender: !!value?.genre,
  //                     birthplace: !!lieu_naissance,
  //                     niveau_scolaire: false,
  //                   });
  //                   setLoader(false);
  //                   setVisibleForm(true);
                  
  //               } else {
  //                 notification.error({
  //                   message: t("Erreur"),
  //                   description: t("Le num de la CIN est erroné."),
  //                   duration: 0,
  //                 });
  //                 setLoader(false);
  //               }
  //             } else {
  //               setLoader(false);
  //             }
  //           })
  //           .catch((error) => {
  //             notification.error({
  //               message: t("Erreur"),
  //               description: t(error?.data?.message),
  //               duration: 0,
  //             });
  //             setLoader(false);
  //           });
  //       }
  //     })
  //     .catch(() => {
  //       setLoader(false);
  //     })

  //     .catch(() => {});
  // };






  const searchClick = () => {
    form
      .validateFields()
      .then(async () => {
        setLoader(true);
        if (
          autreEtablissementCheck.value === parseInt(import.meta.env.VITE_APP_ID_ETABLISSEMENT_ORIGINE_PRIVE) &&
          nationalité === "تونسية"
        ) {
          getInfoApprenantByCinOrPasseport(form.getFieldsValue()["num_cin"])
            .then(async (response) => {
              form.setFieldsValue({
                ...form.getFieldsValue(),
                first_name: response?.prospect?.surname,
                last_name: response?.prospect?.name,
                first_name_ar: response?.prospect?.surname_ar,
                last_name_ar: response?.prospect?.name_ar,
                father_name: response?.prospect?.nom_pere,
                mother_name: response?.prospect?.nom_mere,
                father_name_ar: response?.prospect?.nom_pere_ar,
                mother_name_ar: response?.prospect?.nom_mere_ar,
                gender: response?.prospect?.civilite,
                birthplace: response?.prospect?.lieu_naissance,
                residence_governorate: response?.prospect?.goverment,
                residence_delegation: response?.prospect?.delegation,
                residence_postal_code: response?.prospect?.code_postal,
                marital_status: response?.prospect?.etat_civile,
                email: response?.prospect?.adresse_mail,
                phone: response?.prospect?.tel,
                niveau_scolaire: response?.prospect?.niveau_etud,
                besoins_specifiques:
                  response?.prospect?.besoin_specifique === 1 ? "نعم" : "لا",
              });

              const delegations = await fetchDelegationListByGoverment(
                response?.prospect?.goverment
              );
              setDelegations(delegations.map((e) => ({ ...e, label: e.text })));
              const code_postaux = await fetchPostalCodeListByDelegation(
                response?.prospect?.delegation
              );
              setPostalCodeList(code_postaux);

              setDefaultDisabledFields({
                first_name: !!response?.prospect?.surname,
                last_name: !!response?.prospect?.name,
                first_name_ar: !!response?.prospect?.surname_ar,
                last_name_ar: !!response?.prospect?.name_ar,
                father_name: !!response?.prospect?.nom_pere,
                mother_name: !!response?.prospect?.nom_mere,
                father_name_ar: !!response?.prospect?.nom_pere_ar,
                mother_name_ar: !!response?.prospect?.nom_mere_ar,
                gender: !!response?.prospect?.civilite,
                birthplace: !!response?.prospect?.lieu_naissance,
                niveau_scolaire: response?.prospect?.niveau_etud,
              });
              setLoader(false);
              setVisibleForm(true);
            })
            .catch((error) => {
              notification.error({
                message: t("Erreur"),
                description: t(error?.data?.message),
                duration: 0,
              });
              setLoader(false);
            });
        } else {
          checkCitizenStatusByIdMadDn(
            form.getFieldsValue()["num_extrait_naissance"],
            form.getFieldsValue()["date_naissance"]
          )
            .then(async (responseMad) => {
              const value = await checkCitizenStatusByCinDn(
                form.getFieldsValue()["date_naissance"],
                form.getFieldsValue()["num_cin"]
              );

              if (value !== false) {
                let lieu_naissance = await getCommuneByCodeCommune(
                  value?.commune
                );
                if (
                  responseMad.nom === value?.nomAr &&
                  responseMad.prenom === value?.prenomAr
                ) {
                    form.setFieldsValue({
                      ...form.getFieldsValue(),
                      first_name: value?.prenomFr,
                      last_name: value?.nomFr,
                      first_name_ar: value?.prenomAr,
                      last_name_ar: value?.nomAr,
                      father_name: value?.chainePereFr,
                      mother_name: value?.chaineMereFr,
                      father_name_ar: value?.chainePereAr,
                      mother_name_ar: value?.chaineMereAr,
                      gender: value?.genre === "2" ? "Mme" : "Mr",
                      birthplace: lieu_naissance,
                      niveau_scolaire: "",
                      residence_governorate:"",
                      residence_delegation: "",
                      residence_postal_code: "",
                      marital_status: "",
                      email: "",
                      phone: "",
                      besoins_specifiques:""
                    });

                    setDefaultDisabledFields({
                      first_name: !!value?.prenomFr,
                      last_name: !!value?.nomFr,
                      first_name_ar: !!value?.prenomAr,
                      last_name_ar: !!value?.nomAr,
                      father_name: !!value?.chainePereFr,
                      mother_name: !!value?.chaineMereFr,
                      father_name_ar: !!value?.chainePereAr,
                      mother_name_ar: !!value?.chaineMereAr,
                      gender: !!value?.genre,
                      birthplace: !!lieu_naissance,
                      niveau_scolaire: false,
                    });
                    setLoader(false);
                    setVisibleForm(true);
                  
                } else {
                  notification.error({
                    message: t("Erreur"),
                    description: t("Le num de la CIN est erroné."),
                    duration: 0,
                  });
                  setLoader(false);
                }
              } else {
                setLoader(false);
              }
            })
            .catch((error) => {
              notification.error({
                message: t("Erreur"),
                description: t(error?.data?.message),
                duration: 0,
              });
              setLoader(false);
            });
        }
      })
      .catch(() => {
        setLoader(false);
      })

      .catch(() => {});
  };

  const handleChangeUpload = ({ file, fileList }) => {

      if (file.status !== 'uploading') {
      const newFileList = fileList.slice(-1);
      setFileList(newFileList);
      
      if (newFileList.length === 0) {
        form.setFieldsValue({ pv_session: undefined });
      }
    }
  };
  // const handleChangeUpload = ({ file, fileList }) => {
  //   if (file.status !== "uploading") {
  //     setFileList(fileList.slice(-1));
  //     if (fileList.length === 0) {
  //       setFileList([]);
  //       form.setFieldsValue({ copie_upload: undefined });
  //     }
  //   }
  // };
  return (
    <Spin spinning={loader} tip="" style={{ width: "100%" }}>
      <Card
        className={classes.listeCard}
        bordered={false}
        title={
          <div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              <Button
                size="small"
                style={{ padding: "0px" }}
                htmlType="button"
                type="text"
                onClick={() => navigate(-1)}
              >
                <ChevronLeft />
              </Button>
              <h3>
                {t(
                  "Vérification de l'éligibilité d'un demandeur de formation homologuée"
                )}
              </h3>{" "}
              <DetailsDrawer record={coursData} />
            </div>
          </div>
        }
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          initialValues={{ nationality: "تونسية" }}
        >
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Item
                label="Nationalité - الجنسية"
                name="nationality"
                rules={[
                  {
                    required: true,
                    message: t("Veuillez remplir ce champ."),
                  },
                ]}
              >
                <Select
                  onChange={(e) => {
                    handleResetDisabledFields(e);
                  }}
                  optionFilterProp="label"
                  showSearch
                  options={nationalityOptions}
                  disabled={
                    params.state?.type === "consulter" ||
                    params?.state?.type === "modification" || params?.state?.type === "complement_dossier"
                  }
                />
              </Form.Item>
            </Col>

            <Col xs={24} sm={12}>
              {nationalité === "تونسية" ? (
                <Form.Item
                  label="Établissement de formation d’origine - أخر شهادة في علاقة بالتكوين"
                  name="etab_origin"
                  rules={[
                    {
                      required: nationalité === "تونسية",
                      message: t("Veuillez remplir ce champ."),
                    },
                  ]}
                >
                  <Select
                    showSearch
                    optionFilterProp="label"
                    options={etablissementFormation}
                    disabled={params.state?.type === "consulter"}
                    onChange={(value, option) => {
                      
                      if (value === parseInt(import.meta.env.VITE_APP_ID_ETABLISSEMENT_ORIGINE_EQUIVALENCE)) {
                        setAutreEtablissementCheck((prevState) => ({
                          ...prevState,
                          value: value,
                          check: true,
                        }));
                      } else {
                        setAutreEtablissementCheck((prevState) => ({
                          ...prevState,
                          value: value,
                          check: false,
                        }));

                        if(value === parseInt(import.meta.env.VITE_APP_ID_ETABLISSEMENT_ORIGINE_MINISTERE_EDUCATION))
                        {
                          if(coursData.id_diplome === parseInt(import.meta.env.VITE_APP_ID_DIPLOME_CAP))
                          {
                            setNiveauScolaire(
                              [
                                  {
                                    value: "9ème année secondaire",
                                    label: "9ème année secondaire",
                                  },
                                  {
                                    value: "1ère année secondaire",
                                    label: "1ère année secondaire",
                                  },
                                  {
                                    value: "2ème année secondaire",
                                    label: "2ème année secondaire",
                                  },
                                  {
                                    value: "3ème année secondaire",
                                    label: "3ème année secondaire",
                                  },
                                  {
                                    value: "Baccalauréat",
                                    label: "Baccalauréat",
                                  },
                                ])
                          }
                          else  if(coursData.id_diplome === parseInt(import.meta.env.VITE_APP_ID_DIPLOME_BTP))
                          {
                            setNiveauScolaire(
                              [
                                  {
                                    value: "2ème année secondaire",
                                    label: "2ème année secondaire",
                                  },
                                  {
                                    value: "3ème année secondaire",
                                    label: "3ème année secondaire",
                                  },
                                  {
                                    value: "Baccalauréat",
                                    label: "Baccalauréat",
                                  },
                                  {
                                    value: "CAP homologué dans une spécialité similaire",
                                    label: "CAP homologué dans une spécialité similaire",
                                  },

                                ])
                          }
                          // else  if(coursData.id_diplome === parseInt(import.meta.env.VITE_APP_ID_DIPLOME_BTS))
                          //   {
                          //     setNiveauScolaire(
                          //       [
                          //           {
                          //             value: "Baccalauréat",
                          //             label: "Baccalauréat",
                          //           },
                          //           {
                          //             value: "CAP homologué dans une spécialité similaire",
                          //             label: "CAP homologué dans une spécialité similaire",
                          //           },
  
                          //         ])
                          //   }
                      
                        }
                    
                      }

                      if (nationalité === "تونسية") {
                        setVisibleForm(false);
                      }
                    }}
                  />
                </Form.Item>
              ) : (
                <Form.Item
                  label="Établissement de formation d’origine - مؤسسة التكوين التي حصل منها على آخر شهادة"
                  name="etab_origin"
                  rules={[
                    {
                      required: nationalité === "تونسية",
                      message: t("Veuillez remplir ce champ."),
                    },
                  ]}
                >
                  <Input disabled={params.state?.type === "consulter"} />
                </Form.Item>
              )}
            </Col>

            <Form.Item
              name="autre_etablissement"
              noStyle
              // shouldUpdate={(prevValues, currentValues) =>
              //   prevValues.etab_origin !== currentValues.etab_origin
              // }
            >
              {autreEtablissementCheck?.check && (
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <Form.Item
                    label="Nom du diplôme - اسم الشهادة"
                    name="autre_textarea"
                    rules={[
                      {
                        required: true,
                        message: t("Veuillez remplir ce champ."),
                      },
                      {
                        validator: (_, value) => {
                          if (value && value.trim() === "") {
                            return Promise.reject(
                              t("Veuillez remplir ce champ.")
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <TextArea
                      rows={1}
                      placeholder=""
                      disabled={params?.state?.type === "consulter"}
                    />
                  </Form.Item>
                </Col>
              )}
            </Form.Item>

            <Col
              xs={24}
              sm={24}
              md={nationalité === "تونسية" ? 24 : 12}
              lg={nationalité === "تونسية" ? 24 : 12}
              xl={nationalité === "تونسية" ? 24 : 12}
            >
              <Form.Item
                label="Date de naissance - تاريخ الولادة"
                name="date_naissance"
                rules={[
                  {
                    required: true,
                    message: t("Veuillez remplir ce champ."),
                  },
                ]}
              >
                <DatePicker
                  format="DD/MM/YYYY"
                  placeholder="JJ/MM/AAAAA"
                  disabled={
                    params.state?.type === "consulter" ||
                    params?.state?.type === "modification" || params?.state?.type === "complement_dossier"
                  }
                  style={{ width: "100%" }}
                  onChange={() => {
                    if (nationalité === "تونسية") {
                      setVisibleForm(false);
                    }
                  }}
                  disabledDate={(current) => {
                    const eighteenYearsAgo = dayjs().subtract(18, "years");
                    const today = dayjs();

                    return (
                      current &&
                      (current > today.endOf("day") ||
                        current.isAfter(eighteenYearsAgo))
                    );
                  }}
                />
              </Form.Item>
            </Col>
            {nationalité === "تونسية" && (
              <>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <Form.Item
                    label="Numéro CIN - رقم بطاقة التعريف الوطنية"
                    name="num_cin"
                    maxLength={8}
                    onChange={(e) => {
                      form.setFieldValue(
                        "num_cin",
                        e.target.value.replace(/[^0-9]/g, "")
                      );
                      if (nationalité === "تونسية") {
                        setVisibleForm(false);
                      }
                    }}
                    rules={[
                      {
                        required: true,
                        message: t("Veuillez remplir ce champ."),
                      },
                      {
                        validator: (_, value) => {
                          if (value && !/^\d{8}$/.test(value)) {
                            return Promise.reject(
                              new Error(t("Veuillez vérifier ce champ."))
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input
                      maxLength={8}
                      disabled={
                        params.state?.type === "consulter" ||
                        params?.state?.type === "modification" || params?.state?.type === "complement_dossier"
                      }
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <Form.Item
                    label="Numéro de l'extrait de naissance - رقم مضمون الولادة"
                    name="num_extrait_naissance"
                    onChange={() => {
                      if (nationalité === "تونسية") {
                        setVisibleForm(false);
                      }
                    }}
                    rules={[
                      {
                        required: true,
                        message: t("Veuillez remplir ce champ."),
                      },
                      {
                        validator: (_, value) => {
                          if (value && !/^\d{10}$/.test(value)) {
                            return Promise.reject(
                              new Error(
                                t(
                                  "Le numéro de l'extrait de naissance doit contenir exactement 10 chiffres."
                                )
                              )
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input
                      maxLength={10}
                      disabled={
                        params.state?.type === "consulter" ||
                        params?.state?.type === "modification" || params?.state?.type === "complement_dossier"
                      }
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={10} lg={10} xl={10}>
                  <Form.Item
                    noStyle
                    shouldUpdate={(prevValues, currentValues) =>
                      prevValues.etab_origin !== currentValues.etab_origin
                    }
                  >
                    {({ getFieldValue }) =>
                     idsEtabOrigineMinistere?.includes(getFieldValue("etab_origin")) ? (
                        <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                          <Form.Item
                            label={getFieldValue("etab_origin") === parseInt(import.meta.env.VITE_APP_ID_ETABLISSEMENT_ORIGINE_MINISTERE_EDUCATION) ? "Identifiant du ministère de l'éducation - معرّف وزارة التربية" : "Identifiant du ministère de l'enseignement supérieur - معرّف وزارة التعليم العالي" }
                            name="id_ministere_education"
                          >
                            <Input
                              disabled={params.state?.type === "consulter"}
                              onChange={() => {
                                if (nationalité === "تونسية") {
                                  setVisibleForm(false);
                                }
                              }}
                            />
                          </Form.Item>
                        </Col>
                      ) : null
                    }

                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                  <Form.Item label="  " name="btn_rechercher">
                    <Button
                      id="search"
                      type="primary"
                      icon={<SearchOutlined />}
                      onClick={searchClick}
                      disabled={visibleForm}
                    >
                      {t("Rechercher")}
                    </Button>
                  </Form.Item>
                </Col>
              </>
            )}

            {nationalité !== "تونسية" && (
              <>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <Form.Item
                    label="N° passeport - رقم جواز السفر"
                    name="num_passeport"
                    rules={[
                      {
                        required: true,
                        message: t("Veuillez remplir ce champ."),
                      },
                    ]}
                  >
                    <Input disabled={params.state?.type === "consulter"} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <Form.Item
                    label="Date d'expiration du passeport - تاريخ انتهاء جواز السفر"
                    name="date_expiration_passeport"
                    rules={[
                      {
                        required: true,
                        message: t("Veuillez remplir ce champ."),
                      },
                    ]}
                  >
                    <DatePicker
                      disabled={params.state?.type === "consulter"}
                      format="DD/MM/YYYY"
                      placeholder="JJ/MM/AAAAA"
                      style={{ width: "100%" }}
                      disabledDate={(current) => {
                        return (
                          current &&
                          current < dayjs().add(3, "month").startOf("day")
                        );
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <Form.Item
                    label="Numéro de la carte séjour - رقم بطاقة الإقامة"
                    name="num_carte_sejour"
                    rules={[
                      {
                        required: false,
                        message: t("Veuillez remplir ce champ."),
                      },
                      {
                        validator: (_, value) => {
                          if (value && value.trim() === "") {
                            return Promise.reject(
                              t("Veuillez remplir ce champ.")
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input disabled={params.state?.type === "consulter"} />
                  </Form.Item>
                </Col>
              </>
            )}
          </Row>
          {visibleForm && (
            <Row gutter={16}>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label="Nom (En français)  - اللقب (بالفرنسية)"
                  name="last_name"
                  rules={[
                    {
                      required: true,
                      message: t("Veuillez remplir ce champ."),
                      pattern: /^[a-zA-ZÀ-ÿ\s-]+$/,
                    },
                  ]}
                >
                  <Input disabled={defaultDisabledFields.last_name} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label="Prénom (En français) - الإسم (بالفرنسية)"
                  name="first_name"
                  rules={[
                    {
                      required: true,
                      pattern: /^[a-zA-ZÀ-ÿ\s-]+$/,
                      message: t("Veuillez remplir ce champ."),
                    },
                  ]}
                >
                  <Input disabled={defaultDisabledFields.first_name} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label="Nom (En arabe) - اللقب (بالعربية)"
                  name="last_name_ar"
                  rules={[
                    {
                      required: true,
                      message: t("Veuillez remplir ce champ."),
                    },
                    {
                      pattern: /^[\u0600-\u06FF0-9\s]+$/,
                      message: t(
                        "Veuillez entrer uniquement des caractères arabes."
                      ),
                    },
                    {
                      validator: (_, value) => {
                        if (value && value.trim() === "") {
                          return Promise.reject(
                            t("Veuillez remplir ce champ.")
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input disabled={defaultDisabledFields.last_name_ar} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label="Prénom (En arabe) - الإسم (بالعربية)"
                  name="first_name_ar"
                  rules={[
                    {
                      required: true,
                      message: t("Veuillez remplir ce champ."),
                    },
                    {
                      pattern: /^[\u0600-\u06FF0-9\s]+$/,
                      message: t(
                        "Veuillez entrer uniquement des caractères arabes."
                      ),
                    },
                    {
                      validator: (_, value) => {
                        if (value && value.trim() === "") {
                          return Promise.reject(
                            t("Veuillez remplir ce champ.")
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input disabled={defaultDisabledFields.first_name_ar} />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label="Lieu de naissance (En arabe) - مكان الولادة (بالعربية)"
                  name="birthplace"
                  rules={[
                    {
                      required: true,
                      message: t("Veuillez remplir ce champ."),
                    },
                    {
                      pattern: /^[\u0600-\u06FF0-9\s]+$/,
                      message: t(
                        "Veuillez entrer uniquement des caractères arabes."
                      ),
                    },
                    {
                      validator: (_, value) => {
                        if (value && value.trim() === "") {
                          return Promise.reject(
                            t("Veuillez remplir ce champ.")
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input disabled={defaultDisabledFields.birthplace} />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label="Gouvernorat de résidence - ولاية الإقامة"
                  name="residence_governorate"
                  rules={[
                    {
                      required: true,
                      message: t("Veuillez remplir ce champ."),
                    },
                  ]}
                >
                  <Select
                    optionFilterProp="label"
                    showSearch
                    disabled={params.state?.type === "consulter"}
                    onChange={handleGouvernoratChange}
                    options={gouvernoratOptions}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label="Délégation de résidence - معتمدية الإقامة"
                  name="residence_delegation"
                  rules={[
                    {
                      required: true,
                      message: t("Veuillez remplir ce champ."),
                    },
                  ]}
                >
                  <Select
                    optionFilterProp="label"
                    showSearch
                    disabled={params.state?.type === "consulter"}
                    onChange={handleDelegationChange}
                    options={delegations}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label="Code postal - الترقيم البريدي"
                  name="residence_postal_code"
                  rules={[
                    {
                      required: true,
                      message: t("Veuillez remplir ce champ."),
                    },
                  ]}
                >
                  <Select
                    optionFilterProp="label"
                    showSearch
                    disabled={params.state?.type === "consulter"}
                    options={postalCodeList}
                  />
                </Form.Item>
              </Col>
              {nationalité === "تونسية" ? (

<>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label="Nom du père (En français) - (بالفرنسية) اسم الأب"
                  name="father_name"
                  rules={[
                    {
                      required: true,
                      pattern: /^[a-zA-ZÀ-ÿ\s-]+$/,
                      message: t("Veuillez remplir ce champ."),
                    },
                  ]}
                >
                  <Input disabled={defaultDisabledFields.father_name} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label="Nom de la mère (En français) - (بالفرنسية) اسم الأم"
                  name="mother_name"
                  rules={[
                    {
                      required: true,
                      pattern: /^[a-zA-ZÀ-ÿ\s-]+$/,
                      message: t("Veuillez remplir ce champ."),
                    },
                  ]}
                >
                  <Input disabled={defaultDisabledFields.mother_name} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label="Nom du père (En arabe) - (بالعربية) اسم الأب"
                  name="father_name_ar"
                  rules={[
                    {
                      required: true,
                      message: t("Veuillez remplir ce champ."),
                    },
                    {
                      pattern: /^[\u0600-\u06FF0-9\s]+$/,
                      message: t(
                        "Veuillez entrer uniquement des caractères arabes."
                      ),
                    },
                    {
                      validator: (_, value) => {
                        if (value && value.trim() === "") {
                          return Promise.reject(
                            t("Veuillez remplir ce champ.")
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input disabled={defaultDisabledFields.father_name_ar} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label="Nom de la mère (En arabe) - (بالعربية) اسم الأم"
                  name="mother_name_ar"
                  rules={[
                    {
                      required: true,
                      message: t("Veuillez remplir ce champ."),
                    },
                    {
                      pattern: /^[\u0600-\u06FF0-9\s]+$/,
                      message: t(
                        "Veuillez entrer uniquement des caractères arabes."
                      ),
                    },
                    {
                      validator: (_, value) => {
                        if (value && value.trim() === "") {
                          return Promise.reject(
                            t("Veuillez remplir ce champ.")
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input disabled={defaultDisabledFields.mother_name_ar} />
                </Form.Item>
              </Col></> ) : null}
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label="Genre - الجنس"
                  name="gender"
                  rules={[
                    {
                      required: true,
                      message: t("Veuillez remplir ce champ."),
                    },
                  ]}
                >
                  <Select disabled={defaultDisabledFields.gender}>
                    <Option value="Mme">Féminin - أنثى</Option>
                    <Option value="Mr">Masculin - ذكر</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label="État civil - الحالة الاجتماعية"
                  name="marital_status"
                  rules={[
                    {
                      required: true,
                      message: t("Veuillez remplir ce champ."),
                    },
                  ]}
                >
                  <Select disabled={params.state?.type === "consulter"}>
                    <Option value="Célibataire - أعزب">Célibataire - أعزب</Option>
                    <Option value="Marié(e) - متزوج/متزوجة">
                      Marié(e) - متزوج/متزوجة
                    </Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label="Adresse e-mail - البريد الإلكتروني"
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: t("Veuillez remplir ce champ."),
                    },
                    {
                      type: "email",
                      message: t("Veuillez vérifier ce champ."),
                    },
                  ]}
                >
                  <Input disabled={params.state?.type === "consulter"} />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label="Numéro de téléphone - رقم الهاتف"
                  name="phone"
                  rules={[
                    {
                      required: true,
                      message: t("Veuillez remplir ce champ."),
                    },
                    {
                      pattern: new RegExp(/^\d{8}$/),
                      message: t("Veuillez vérifier ce champ."),
                    },
                  ]}
                >
                  <Input
                    disabled={params.state?.type === "consulter"}
                    maxLength={8}
                    onChange={(e) =>
                      form.setFieldValue(
                        "phone",
                        e.target.value.replace(/[^0-9]/g, "")
                      )
                    }
                  />
                </Form.Item>
              </Col>
              {
                autreEtablissementCheck?.value !== parseInt(import.meta.env.VITE_APP_ID_ETABLISSEMENT_ORIGINE_MINISTERE_ENSEIGNEMENT_SUPERIEUR) && 
                (
                  <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                  <Form.Item
                    label="Niveau scolaire - المستوى الدراسي"
                    name="niveau_scolaire"
                    disabled={params.state?.type === "consulter"}
                    rules={[
                      {
                        required: true,
                        message: t("Veuillez remplir ce champ."),
                      },
                    ]}
                  >
                    <Select
                      options={niveauScolaire}
                      // disabled={defaultDisabledFields.niveau_scolaire}
                    />
                  </Form.Item>
                </Col>
                )
              }
             

              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  label="Personne à besoin spécifique - شخص ذو إحتياجات خصوصية "
                  name="besoins_specifiques"
                  rules={[
                    {
                      required: true,
                      message: t("Veuillez remplir ce champ."),
                    },
                  ]}
                >
                  <Radio.Group disabled={params.state?.type === "consulter"}>
                    <Radio value="نعم">Oui - نعم</Radio>
                    <Radio value="لا">Non - لا</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>


  <Col sm={24} md={24} lg={24}>
    <Form.Item
      name="copie_upload"
      label={
        <label className="label">
          {
            autreEtablissementCheck?.value === parseInt(import.meta.env.VITE_APP_ID_ETABLISSEMENT_ORIGINE_MINISTERE_EDUCATION)
              ? "نسخة من شهادة مدرسية"
              : autreEtablissementCheck?.value  === parseInt(import.meta.env.VITE_APP_ID_ETABLISSEMENT_ORIGINE_EQUIVALENCE)
              ? "équivalence"
              : "Diplôme"
          }
        </label>
      }
      rules={[{ required: true, message: "Veuillez remplir ce champ." }]}
    >
      <Dragger
       disabled={params.state?.type === "consulter"}
        onChange={handleChangeUpload}
        fileList={fileList}
        beforeUpload={() => false}
        maxCount={1}
        listType="picture"
        accept=".jpg,.jpeg,.png,.pdf"
         onPreview={(file) => {
          if(file?.originFileObj) 
          {
          const url = URL.createObjectURL(file?.originFileObj);
            window.open(url, "_blank");
          }
          else if (file?.url) {
            window.open(file?.url, "_blank");
          }
        }}
        // onPreview={(file) => {
        //   if (file.url) {
        //     window.open(file.url, "_blank");
        //   }
        // }}
      >
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">
          Cliquez ou déposez votre fichier ici pour le télécharger - انقر أو اسحب ملفك هنا لتحميله.
        </p>
        <p className="ant-upload-hint">
          Formats acceptés - الملفات المسموح بها : .jpg, .jpeg, .png, .pdf.
        </p>
      </Dragger>
    </Form.Item>
  </Col>

            

              <Divider />

              {params.state?.type !== "consulter" && (
                <Form.Item
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    width: "100%",
                  }}
                >
                  <div style={{ display: "flex", gap: "10px" }}>
                    <Button htmlType="button">Annuler</Button>

                    <Button type="primary" htmlType="submit">
                      {params.state?.type === "modification"
                        ? "Modifier" 
                        : "Soumettre"}
                    </Button>
                  </div>
                </Form.Item>
              )}
            </Row>
          )}
        </Form>
      </Card>
    </Spin>
  );
};

export default PreInscritForm;
